import { useEffect, useState } from 'react';
import { getOwnSubjects, toSectionGroups } from '../../Subject/services/subjectService';
import { getOwnAdvisory } from '../../Teacher/services/teacherService';
import { getStudents } from '../../Student/services/studentService';

// The numbers shown on a teacher's dashboard: how many subjects they teach, how many sections that
// spans, how many students that covers (the taught sections plus the advisory section, the same list
// as their Students page), and their advisory section with its size. `kpis` stays null if loading failed.
export function useTeacherKpis(enabled) {
  const [kpis, setKpis] = useState(null);
  const [loading, setLoading] = useState(enabled);

  useEffect(() => {
    if (!enabled) return undefined;
    let mounted = true;

    (async () => {
      const [subjects, advisory] = await Promise.all([getOwnSubjects(), getOwnAdvisory()]);

      const taughtGroups = toSectionGroups(subjects);
      const groups = [...taughtGroups];
      if (advisory && !groups.some((g) => g.grade_level === advisory.grade_level && g.section === advisory.section)) {
        groups.push(advisory);
      }

      // Only the totals are needed, so ask for a single row and read the count.
      const [students, advisees] = await Promise.all([
        getStudents({ groups, pageSize: 1 }),
        advisory ? getStudents({ groups: [advisory], pageSize: 1 }) : null,
      ]);

      return {
        subjects: subjects.length,
        sections: taughtGroups.length,
        students: students.count,
        advisory: advisory ? { ...advisory, students: advisees.count } : null,
      };
    })()
      .then((result) => {
        if (mounted) setKpis(result);
      })
      .catch(() => {
        // The cards fall back to "—"; the quick links below still work.
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, [enabled]);

  return { kpis, loading };
}
